import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Globe, ChevronDown } from "lucide-react";
import { SUPPORTED_LANGUAGES } from "../../i18n";

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const shortCode = i18n.language ? i18n.language.split("-")[0] : "en";
  const currentLang = SUPPORTED_LANGUAGES.find((l) => l.code === shortCode) || SUPPORTED_LANGUAGES[0];

  const handleLanguageChange = (code: string) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      {isOpen && (
        <div
          className="fixed inset-0 z-45 cursor-default"
          onClick={() => setIsOpen(false)}
        />
      )}

      <button
        onClick={() => setIsOpen(!isOpen)}
        aria-label={currentLang.label}
        className="flex items-center gap-2 min-h-10 sm:min-h-0 hover:bg-sidebar-hover/10 px-2 py-1.5 rounded-md transition-colors"
      >
        <Globe className="h-4 w-4 text-text-muted" />
        <span className="text-sm text-text hidden sm:block font-medium">
          {currentLang.flag} {currentLang.label}
        </span>
        <ChevronDown
          className={`h-4 w-4 text-text-muted transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-40 bg-surface border border-border rounded-md shadow-lg z-50 py-1 origin-top-right animate-in fade-in slide-in-from-top-1 duration-100">
          {SUPPORTED_LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`w-full flex items-center gap-2 px-4 py-2 text-sm text-left hover:bg-sidebar-hover/10 transition-colors ${
                currentLang.code === lang.code
                  ? "text-brand font-semibold"
                  : "text-text"
              }`}
            >
              <span>{lang.flag}</span>
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
export default LanguageSelector;
